import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { BaseController } from '../base.controller';
import { HomeController } from '../home/home.controller';
import { HColor } from '@shared/src/public-api';

@Injectable({
    providedIn: 'root',
})
export class PortAddressController extends BaseController {
    private base = "/portaddress"

    constructor(protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router) {
        super(http, alertService, translateService, loadingService, router);
    }

    public getOriginDestinationClassification(classification: string, type: string): Observable<PortAddressOriginDestinationClassificationDTO> {
        return this.get(this.base + "/origindestination/classification/" + classification + "/" + type);
    }
    public setOriginDestinationClassification(classification: string, originId: number, destinationId: number): Observable<boolean> {
        return this.post(this.base + "/origindestination/classification/" + classification, { 'originId': originId, 'destinationId': destinationId }, "setOriginDestinationClassification");
    }


    public comparePortAddress(a: PortAddressOriginDestinationClassificationItemDTO, b: PortAddressOriginDestinationClassificationItemDTO) {
        if (a.selected)
            return 1;
        if (a.score < b.score)
            return -1;
        if (a.score > b.score)
            return 1;
        if (a.portAddressId < b.portAddressId)
            return -1;
        return 1;
    }

}

export class PortAddressOriginDestinationClassificationDTO {
    public originList: Array<PortAddressOriginDestinationClassificationItemDTO>;
    public destinationList: Array<PortAddressOriginDestinationClassificationItemDTO>;
    public defaultOriginId: number;
    public defaultDestinationId: number;
    public originListCount: number;
    public destinationListCount: number;
}

export class PortAddressOriginDestinationClassificationItemDTO {
    public portAddressId: number;
    public addressKey: string;
    public skin: string;
    public description: string;
    public score: number;
    public selected: boolean;
    public skinToShow: string;
    public country: string;
    public port: string;

    static copy(from: PortAddressOriginDestinationClassificationItemDTO, to: PortAddressOriginDestinationClassificationItemDTO) {
        to.portAddressId = from.portAddressId;
        to.addressKey = from.addressKey;
        to.skin = from.skin;
        to.description = from.description;
        to.score = from.score;
        to.selected = from.selected;
        to.skinToShow = from.skinToShow;
        to.country = from.country;
        to.port = from.port;
    }
}


export class PortAddressItemSelectorDto extends PortAddressOriginDestinationClassificationItemDTO {
    public color: string;
    public backgroundColor: string;
    public barra: boolean;
    public style: any;

    public static build(item: PortAddressOriginDestinationClassificationItemDTO, barra: boolean, homeController: HomeController): PortAddressItemSelectorDto {
        let result: PortAddressItemSelectorDto = new PortAddressItemSelectorDto();

        PortAddressOriginDestinationClassificationItemDTO.copy(item, result);

        result.backgroundColor = HColor.getColorFromStringTable(item.addressKey, homeController);
        result.color = HColor.getWhiteBlackFromColor(result.backgroundColor);

        result.style = { 'color': result.color, 'backgroundColor': result.backgroundColor };

        result.barra = barra;
        return result;
    }
}